"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var GeoBlocked = function (_a) {
    var website = _a.website, supportEmail = _a.supportEmail;
    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement("img", { src: "/img/logo.svg", alt: website }),
            react_1.default.createElement("h1", { className: styles_module_scss_1.default.title }, "Country blocked"),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.descriptionSecondary }, "Unfortunately, website is not available in your country."),
            react_1.default.createElement("div", { className: styles_module_scss_1.default.infoBlock },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.infoRow },
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.iconImage, src: "/img/lock.svg", alt: "Lock" }),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.subTitle }, "NOT IN A RESTRICTED COUNTRY?"),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.description }, "If you are using VPN or a proxy server, try to turn it off and reload the page."))),
                react_1.default.createElement("div", { className: styles_module_scss_1.default.infoRow },
                    react_1.default.createElement("img", { className: styles_module_scss_1.default.iconImage, src: "/img/letter.svg", alt: "Letter" }),
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.subTitle }, "CONTACT US"),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.description },
                            "Do you need to contact us? Email us at ",
                            supportEmail)))))));
};
exports.default = GeoBlocked;
